module.exports = __webpack_public_path__ + "images/emoji/five.ca6919a166babfb925bb.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/five.png
// module id = ouMD
// module chunks = 13